/*** IMPORTS FROM imports-loader ***/
var define = false;

require('../../modules/es6.object.define-property');
var $Object = require('../../modules/_core').Object;
module.exports = function defineProperty(it, key, desc){
  return $Object.defineProperty(it, key, desc);
};



//////////////////
// WEBPACK FOOTER
// ./~/.npminstall/core-js/2.4.1/core-js/library/fn/object/define-property.js
// module id = 167
// module chunks = 0